import { render, staticRenderFns } from "./ModalSuccessSubmitRetur.vue?vue&type=template&id=4d795ac6&"
import script from "./ModalSuccessSubmitRetur.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessSubmitRetur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports